import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Stack, Checkbox, Label } from '@guestyci/arc';

const RememberDeviceCheckbox = ({ id, checked, onCheckedChange, disabled }) => (
  <Stack direction="row" spacing={2} align="center">
    <Checkbox
      id={id}
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      disabled={disabled}
    />
    <Label htmlFor={id} className="gst-cursor-pointer">
      {t('Do not challenge me on this device again')}
    </Label>
  </Stack>
);

export default RememberDeviceCheckbox;
